import event from '@drivesally/sally-fw/lib/event/event';

export default event('/crm/ticket/details/show');
